export default __webpack_public_path__ + "static/media/180.87662df0.jpg";